import { ArrowLeft, Mail, MapPin } from "lucide-react";
import { site } from "../content/site";

export const ContactPage = () => (
  <main className="border-t border-gray-200 bg-white" data-testid="contact-page">
    <section className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:px-8 lg:py-20">
      <div>
        <a
          href="/"
          className="inline-flex items-center gap-2 rounded-sm text-sm font-semibold text-brand transition-colors duration-200 hover:text-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Back to Home
        </a>

        <p className="mt-10 text-xs font-semibold uppercase tracking-[0.14em] text-brand">
          {site.contactPage.eyebrow}
        </p>
        <h1 className="mt-4 max-w-2xl font-heading text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
          {site.contactPage.title}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-gray-600 md:text-lg">
          {site.contactPage.intro}
        </p>
      </div>

      <div className="rounded-lg border border-gray-200 bg-gray-50 p-6 sm:p-8">
        <div className="space-y-6">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-gray-400">
              {site.contactPage.emailLabel}
            </p>
            <a
              href={`mailto:${site.contact.email}`}
              data-testid="contact-email-link"
              className="mt-2 inline-flex items-center gap-2 rounded-sm text-base font-semibold text-brand transition-colors duration-200 hover:text-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
            >
              <Mail className="h-4 w-4" aria-hidden="true" />
              {site.contact.email}
            </a>
          </div>

          <div className="border-t border-gray-200 pt-6">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-gray-400">
              {site.contactPage.locationLabel}
            </p>
            <p
              className="mt-2 flex items-center gap-2 text-base font-semibold text-gray-900"
              data-testid="contact-address"
            >
              <MapPin className="h-4 w-4 text-brand" aria-hidden="true" />
              {site.contact.address}
            </p>
          </div>

          <p className="border-t border-gray-200 pt-6 text-sm leading-relaxed text-gray-600">
            {site.contactPage.responseNote}
          </p>

          <a
            href={`mailto:${site.contact.email}`}
            data-testid="contact-page-cta"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-brand px-5 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand sm:w-auto"
          >
            <Mail className="h-4 w-4" aria-hidden="true" />
            {site.contactPage.ctaLabel}
          </a>
        </div>
      </div>
    </section>
  </main>
);
